import { PathOptions } from "leaflet";

export const ufv_base_existente = (feature: any): PathOptions => {
  return {
    color: "#FFD700",
    weight: 2,
    opacity: 1,
    fillColor: "#FF8C00",
    fillOpacity: 0.6,
  };
};
